// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".k-tour-get-started[data-v-1d1ed2f0]{position:relative;overflow:hidden}@media screen and (min-width:960px){.k-tour-get-started .title--regular[data-v-1d1ed2f0]{font-size:36px!important}}.k-tour-get-started__img[data-v-1d1ed2f0]{position:absolute;bottom:-10px;right:0;width:50%!important}@media screen and (max-width:959px){.k-tour-get-started__img[data-v-1d1ed2f0]{bottom:-60px}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
